import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { uploadClientUsers, getCsvClientUserModel } from '../app/store/actions/clientUsers';
import ModalComponent from '../components/modal';
import UploadFilesComponent from '../components/upload';
import ImportErrors from '../components/upload/ImportErrors';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class UploadClientUsersPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      showModal: false,
      titleModal: '',
      titleModalBody: '',
      importMessage: null,
      instructions: [
        { field: 'similarityPermission', translation: 'visualizeSimilarity' },
        { field: 'crossSellingPermission', translation: 'visualizeCrossselling' },
        { field: 'stockPermission', translation: 'visualizeStock' },
        { field: 'leadTimePermission', translation: 'visualizeLeadtime' },
        { field: 'opicCodePermission', translation: 'Ver código Sonepar' },
        { field: 'soneparCodePermission', translation: 'visualizeSoneparCode' },
        { field: 'cartPermission', translation: 'visualizeCart' },
        { field: 'clientCodePermission', translation: 'visualizeClientCode' },
        { field: 'cartUsersPermission', translation: 'cartUser' },
        { field: 'purchaseEstimatePermission', translation: 'generateEstimate' },
        { field: 'pricePermission', translation: 'visualizePrice' },
        { field: 'spotPermission', translation: 'visualizeSpot' },
        { field: 'purchaseCreditPermission', translation: 'finalizePurchaseCredit' },
        { field: 'purchaseDebitPermission', translation: 'finalizePurchaseDebit' },
        { field: 'purchaseBankSlipPermission', translation: 'finalizePurchaseBankSlip' },
        { field: 'purchaseBillingPermission', translation: 'finalizePurchaseBilling' },
        { field: 'purchasePaymentGateway', translation: 'finalizePurchasePaymentGateway' },
        { field: 'visualizeAllOrdersPermission', translation: 'visualizeAllOrders' },
        { field: 'clientWithdraw', translation: 'clientWithdraw' },
      ]
    };
  }

  sendFile = async (file) => {
    await this.setState({
      errors: {},
      importMessage: null,
    });

    try {
      const result = await this.props.uploadClientUsers(file);
      await this.setState({
        errors: (result && result.errors) || [],
        importMessage: (result && result.created)
          ? I18n.t('successfulImportMessage', { 0: result.created })
          : null,
      });
      // eslint-disable-next-line no-empty
    } catch (error) { }
  }

  modelDownload = async () => {
    try {
      await this.props.getCsvClientUserModel();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  goBack = () => {
    history.push(ROUTES.CLIENTS);
  }

  render() {
    const {
      errors, showModal, titleModal, titleModalBody, importMessage,
      instructions,
    } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2>{I18n.t('importClientUsers')}</h2>
          <div className="upload-text">
            <p><strong>{I18n.t('importText1')}</strong></p>
            <p>{I18n.t('importText2')}</p>
            <p>{I18n.t('importText3')}</p>
            <p>{`${I18n.t('importClientUsers1')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{`${I18n.t('importClientUsers2')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            {/* <p>{`${I18n.t('importClientUsers3')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p> */}
            <p>{`${I18n.t('importClientUsers4', { 0: 'contracts', 1: I18n.t('contract') })} `}</p>
            {instructions.map(elem => (
              <p>
                {`${I18n.t('importClientUsers5', { 0: elem.field, 1: I18n.t(elem.translation) })} `}
                <strong className="text-danger">{I18n.t('mandatory')}</strong>
              </p>
            ))}
            <p>
              {`${I18n.t('importClientUsers4', { 0: 'deliveryCode', 1: I18n.t('deliveryLocation') })} `}
              <strong className="text-danger">{I18n.t('mandatory')}</strong>
            </p>
            <p>
              {`${I18n.t('importClientUsers6', { 0: 'locationId', 1: I18n.t('place') })} `}
              <strong className="text-danger">{I18n.t('mandatory')}</strong>
            </p>
            <p>
              {`${I18n.t('importClientUsers6', { 0: 'bu', 1: I18n.t('bu') })} `}
              <strong className="text-danger">{I18n.t('mandatory')}</strong>
            </p>
            <p>
              {`${I18n.t('importClientUsers4', { 0: 'deposit', 1: I18n.t('deposit') })} `}
              <strong className="text-danger">{I18n.t('mandatory')}</strong>
            </p>
            <p>{I18n.t('importClientUsers7', { 0: 'approveId1', 1: I18n.t('approved1') })}</p>
            <p>{I18n.t('importClientUsers7', { 0: 'approveId2', 1: I18n.t('approved2') })}</p>
            <p>{I18n.t('importClientUsers8', { 0: 'limit', 1: I18n.t('limitText') })}</p>
          </div>

          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            importMessage={importMessage}
            itemsErrors={(
              <ImportErrors
                title={I18n.t('customerUserNotAdded')}
                errorMessage=""
                errors={errors}
              />
            )}
          />

          <ModalComponent
            title={titleModal}
            body={titleModalBody}
            visible={showModal}
            closeModal={() => this.setState({ showModal: false })}
            titleOkButtoon={I18n.t('ok')}
            size={{ width: '350px', height: '200px' }}
            showButtons
            confirmModal={() => this.setState({ showModal: false })}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadClientUsers: file => dispatch(uploadClientUsers(file)),
  getCsvClientUserModel: () => dispatch(getCsvClientUserModel()),
});

export default connect(null, mapDispatchToProps)(UploadClientUsersPage);
